module.exports = __webpack_public_path__ + "img/m1.1212ffb5.svg";